import React, { useState, useEffect } from "react";
import { Tabs, Tab, Paper } from "@material-ui/core";
import { Club } from "api/clubs";
import { ClubSelect, HelpscoutFab } from "components";
import { Membership } from "api/memberships";
import ReportsTab from "./ReportsTab";
import InvoicesTab from "./InvoicesTab";
import i18n from "./i18n";
import DocumentsTab from "./DocumentsTab";

// prop types
interface DocumentsViewProps {
    club: Club | null,
    memberships: Membership[],
}

// documents section for contract docs, reports and invoices
const DocumentsView = ({ club, memberships }: DocumentsViewProps) => {
    // ui state
    const [clubId, setClubId] = useState<string | undefined>();
    const [currentTab, setCurrentTab] = useState(0);

    // reset ui
    useEffect(() => {
        setClubId(club?.id);
        setCurrentTab(0);
    }, [club]);
    useEffect(() => {
        if (club && currentTab === 0 && !clubId) setClubId(club.id); // no "all" for first tab
    }, [club, currentTab, clubId]);

    // render
    const isOwnerOrAll = memberships.find((m) => m.club.id.startsWith(clubId || ""))?.userRole === "owner";
    const isCompany = memberships.find((m) => m.club.id === clubId)?.club.capabilities.includes("company");
    return (
        <>
            <HelpscoutFab club={club} />
            <Paper style={{ display: "flex", justifyContent: "space-between" }}>
                {/* tabs */}
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    value={currentTab}
                    onChange={(e, index) => setCurrentTab(index)}
                >
                    <Tab label={i18n.documents} />
                    {isOwnerOrAll && <Tab label={i18n.reports} />}
                    {isOwnerOrAll && <Tab label={i18n.invoices} />}
                </Tabs>

                {/* club select */}
                <ClubSelect
                    clubId={clubId}
                    controlProps={{ style: { minWidth: "96px", marginRight: "8px" } }}
                    hideAll={currentTab === 0}
                    userRoles={(currentTab >= 1) ? ["owner"] : ["admin", "owner"]}
                    onChange={setClubId}
                />
            </Paper>
            {currentTab === 0 && <DocumentsTab isCompany={isCompany} clubId={clubId} isOwner={isOwnerOrAll} />}
            {currentTab === 1 && <ReportsTab clubId={clubId} />}
            {currentTab === 2 && <InvoicesTab clubId={clubId} onSetClubId={setClubId} />}
        </>
    );
};

export default DocumentsView;
